import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./FooterMedia.css";
import logolight from "../../images/logo-light.png"; // Adjust the path as necessary
import TPCUnifiedBackdrop from "../../homePage/productPageModern/TPCUnifiedBackdrop";
import { HashLink } from "react-router-hash-link";

const FooterMedia = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const TIKTOK_SVG = `data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none"><circle cx="24" cy="24" r="24" fill="#000"/><path d="M33.2 18.7c-1.9-.1-3.6-.9-4.7-2.2-.9-1-1.4-2.3-1.5-3.7h-3.8v17.4c0 2.1-1.7 3.8-3.8 3.8s-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8c.4 0 .8.1 1.2.2v-3.9c-.4-.1-.8-.1-1.2-.1-4.2 0-7.6 3.4-7.6 7.6s3.4 7.6 7.6 7.6 7.6-3.4 7.6-7.6V23c1.6 1.1 3.5 1.8 5.5 1.8h.7v-3.8c-.7 0-1.4-.1-2-.3z" fill="#fff"/></svg>`)}`;
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToPrograms = (filter = null) => {
    // If we're not on the home page, navigate to home first
    if (location.pathname !== "/") {
      navigate(filter ? `/?filter=${filter}` : "/");
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const programsSection = document.getElementById("programs-section");
        if (programsSection) {
          programsSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 500);
    } else {
      // We're already on the home page, just scroll
      if (filter) {
        navigate(`/?filter=${filter}`);
      }
      const programsSection = document.getElementById("programs-section");
      if (programsSection) {
        programsSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  return (
    <TPCUnifiedBackdrop>
      <div className="footer-media-container">
        {/* Section 1 */}
        <div className="footer-media-section">
          <h2 className="footer-media-heading">
            Interested in Learning Top Tech Skills?
          </h2>
          <button
            className="apply-now-footer-media"
            onClick={() =>
              window.open("https://andus.co.za/applicant-register", "_blank")
            }
          >
            Apply Now
          </button>
        </div>

        {/* Section 2 */}
        <div className="footer-media-links">
          <a href="/about" className="footer-media-link">
            About Tech Performance Centre
          </a>
          <a href="/programs/softwareDeveloper" className="footer-media-link">
            Software developer learning path
          </a>
          <a href="/programs/AIDeveloper" className="footer-media-link">
            AI developer & data science learning path
          </a>
          <a href="/programs/cyber-security" className="footer-media-link">
            Cyber Security learning path
          </a>
          <a href="/pricing" className="footer-media-link">
            Pricing
          </a>
          <a href="/programs/AITools" className="footer-media-link">
            AI in the workplace
          </a>
          <a
            href="/corporate-training/practical-ai"
            className="footer-media-link"
          >
            Cyber Security in the age of AI
          </a>
          <HashLink
            smooth
            to="/about#tpc-contact-us"
            className="footer-media-link"
          >
            Contact us
          </HashLink>
        </div>

        {/* Section 3 */}
        <div className="footer-media-section">
          <h3 className="footer-media-subheading footer-media-subheading-gold">
            Connect
          </h3>
          <div className="footer-media-social">
            <a
              href="https://www.facebook.com/TPCPerformanceCentre"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2F10464408.png?alt=media"
                alt="Facebook"
                className="footer-media-social-icon"
              />
            </a>
            <a
              href="https://www.instagram.com/tpcperformancecentre/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2Finsta.png?alt=media"
                alt="Instagram"
                className="footer-media-social-icon"
              />
            </a>
            <a
              href="https://www.linkedin.com/company/107660745/admin/dashboard/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2Flinked.png?alt=media"
                alt="LinkedIn"
                className="footer-media-social-icon"
              />
            </a>
            <a
              href="https://whatsapp.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2Fwhatsapp.png?alt=media"
                alt="WhatsApp"
                className="footer-media-social-icon"
              />
            </a>
            <a
              href="https://x.com/TPCpta"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://firebasestorage.googleapis.com/v0/b/tech-performance-centre.firebasestorage.app/o/signatures%2F10464257.png?alt=media"
                alt="X (Twitter)"
                className="footer-media-social-icon"
              />
            </a>
            <a
              href="https://www.tiktok.com/@techperformancecentre?_r=1&_t=ZS-93cMfGLf673"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={TIKTOK_SVG}
                alt="TikTok"
                className="footer-media-social-icon"
              />
            </a>
          </div>
        </div>

        {/* Section 4 */}
        <div className="footer-media-divider"></div>
        <div className="footer-media-section">
          <h3 className="footer-media-subheading footer-media-subheading-gold">
            Accreditations and Compliance
          </h3>
          <div className="footer-media-accreditations-text">
            <p>QCTO Accreditation Number:2006/021703/07 </p>
            <p>Department of Higher Education Registration: 2009/FET07/088 </p>
          </div>
        </div>

        {/* Section 6 */}
        <div className="footer-media-logo">
          <img src={logolight} alt="Tech Performance Centre Logo" />
        </div>

        {/* Section 7 */}
        <div className="footer-media-rights">
          <p>© Tech Performance Centre. All rights reserved.</p>
        </div>
      </div>
    </TPCUnifiedBackdrop>
  );
};

export default FooterMedia;
